import divider from './divider.vue'

divider.install = function(Vue) {
  Vue.component(divider.name, divider)
}

export default divider
